<template>
  <header
    :style="headerStyle"
    class="header-preview-component overflow-hidden"
    :class="{
      'image-background': !isVideoBackground,
      'video-background': isVideoBackground
    }"
  >
    <div class="content-container">
      <div v-if="backButton" class="d-flex justify-content-start">
        <router-link
          class="btn btn-back ml-0 text-decoration-none m-0"
          :to="homeRoute"
        >
          <i class="icon-chevron-left mr-2"></i>
        </router-link>
      </div>
      <img
        v-if="showDefaultPlaceholder"
        class="img-partner-placeholder"
        :src="$setup.partnerLogo"
      />
      <div class="component-container">
        <div class="container-fluid">
          <h1
            :class="
              `page-title ${showDefaultPlaceholder ? 'no-cover' : ''} header`
            "
          >
            {{ module.name }}
          </h1>
          <div class="current-progress">
            <p
              :class="
                `page-description-info ${
                  showDefaultPlaceholder ? 'no-cover' : ''
                } mt-2 mb-4`
              "
            >
              {{ description || "" }}
            </p>
            <router-link
              v-if="lesson"
              class="btn btn-info btn-light mb-4 px-3"
              :to="{
                name: 'lesson',
                params: { id: lesson.module.id, lesson: lesson.id }
              }"
            >
              <i class="icon-play mr-2" />
              <span v-if="lesson.progress && !lesson.progress.finished_at">
                Continuar
              </span>
              <span v-else>Começar</span>
            </router-link>
            <p
              v-else-if="showEmptyMsg"
              :class="
                `page-description-info ${
                  showDefaultPlaceholder ? 'no-cover' : ''
                } mt-2 mb-4`
              "
            >
              Módulo sem aulas cadastradas até o momento.
            </p>
          </div>
          <p
            :class="`page-subtitle-info ${!cover ? 'no-cover' : ''} mt-2 mb-4`"
          >
            {{ additionalInfo }}
          </p>
        </div>
        <div class="container-fluid">
          <last-lessons
            class="d-none d-xl-block"
            :data="lastLessons"
            v-if="isVideoBackground"
          ></last-lessons>
        </div>
      </div>

      <div v-if="showCertificate && certificateAvailable" class="certificate">
        <a
          :href="certificateUrl"
          target="_blank"
          class="btn d-inline-flex align-items-center justify-content-center text-light"
        >
          Certificado disponível
        </a>
      </div>
    </div>
    <video-background
      v-if="module.cover_view_type == 'video' && videoURL"
      :url="videoURL"
      class="d-none d-md-block"
    />
    <!-- <mini-player
      class="d-none d-lg-block"
      v-if="module.cover_view_type == 'image_and_video'"
      :url="module.link_video"
    /> -->
    <div
      v-if="!showDefaultPlaceholder"
      class="overlay"
      :class="`theme-${$setup.theme}`"
    ></div>
  </header>
</template>
<script>
import VideoBackground from "@/components/preview/VideoBackground";
import LastLessons from "@/components/home/LastLessons.vue";
// import MiniPlayer from "@/components/preview/MiniPlayer";
import headerCover from "@/mixins/headerCover";
import { mapGetters, mapState } from "vuex";
import get from "lodash/get";
export default {
  mixins: [headerCover],
  components: {
    VideoBackground,
    LastLessons
    // MiniPlayer
  },
  props: {
    backButton: {
      type: Boolean,
      default: false
    },
    showProgress: {
      type: Boolean,
      default: false
    },
    showEmptyMsg: {
      type: Boolean,
      default: false
    },
    showCertificate: {
      type: Boolean,
      default: false
    },
    lesson: {
      type: Object,
      default: () => {}
    },
    module: {
      type: Object,
      default: () => {}
    },
    lastLessons: {
      type: Array,
      default: () => []
    },
    additionalInfo: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState("user", ["certificateStatus"]),
    ...mapState("user", ["course_info"]),
    ...mapState(["setup"]),
    ...mapGetters(["isPortal", "homeRoute"]),
    ...mapGetters("portal", ["activeContent"]),
    videoURL() {
      if (this.isMobileDevice) {
        return this.module.link_video_mobile;
      }

      return this.module.link_video;
    },
    isVideoBackground() {
      return this.module.cover_view_type === "video" && this.videoURL;
    },
    placeholder() {
      return this.resolveHeaderPlaceholderCover(this.setup);
    },
    cover() {
      return this.resolveHeaderCover(this.module, this.setup);
    },
    showDefaultPlaceholder() {
      const existCoverOrPlaceholder = this.cover || this.placeholder;

      if (this.isMobileDevice) {
        if (this.module.cover_view_type_mobile == "image") {
          return !existCoverOrPlaceholder;
        }

        if (
          ["video", "image_and_video"].includes(
            this.module.cover_view_type_mobile
          )
        ) {
          return !existCoverOrPlaceholder && !this.module.link_video_mobile;
        }
      }

      if (this.module.cover_view_type == "image") {
        return !existCoverOrPlaceholder;
      }

      if (["video", "image_and_video"].includes(this.module.cover_view_type)) {
        return !existCoverOrPlaceholder && !this.module.link_video;
      }

      return !existCoverOrPlaceholder && !this.module.link_video;
    },
    headerStyle() {
      const colorFrom = this.$setup.theme === "dark" ? "black" : "#353945";
      const colorTo =
        this.$setup.theme === "dark" ? "rgba(0,0,0,0)" : "#35394500";

      const url = this.cover || this.placeholder || false;

      if (url) {
        return `background-image: linear-gradient(to right, ${colorFrom}, ${colorTo} 50%), url("${url}")`;
      }

      const bgColor = this.$setup.theme === "dark" ? "#151823" : "#DFE1E8";

      return `background-color: ${bgColor}`;
    },
    certificateUrl() {
      const hash = get(this.certificateStatus, "hash_token", "");
      const productId = get(this.certificateStatus, "product_id", "");
      return `https://api.members.velora.com.br/v1/accounts/students/${hash}/product/${productId}/generate/certificate`;
    },
    hourlyLoad() {
      if (this.isPortal) {
        return get(this.activeContent, "hourly_load", false);
      }

      return this.setup.hourly_load;
    },
    certificateEnabled() {
      if (this.isPortal) {
        return !!get(this.activeContent, "certificate_enabled", false);
      }

      return true;
    },
    hasOwnDelivery() {
      return !this.isPortal || !!this.$user.course;
    },
    certificateAvailable() {
      return (
        this.hasOwnDelivery &&
        this.certificateEnabled &&
        this.hourlyLoad &&
        get(this.certificateStatus, "certificate_status") === "available"
      );
    },
    progressStyle() {
      return { "--progress": this.module.progress };
    }
  }
};
</script>
<style lang="scss" scoped>
.header-preview-component {
  position: relative;
  color: white;
  background-size: cover;
  background-position-x: center;
  background-position-y: center;
  animation: fadeInAnimation ease 2s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;

  @media screen and (max-width: 768px) {
    padding-top: 89%;
  }

  &.image-background {
    padding-top: 28.875%;
    @media screen and (max-width: 991px) {
      padding-top: 89%;
    }
    @media screen and (max-width: 576px) {
      padding-top: 132%;
    }
  }

  &.video-background {
    @media screen and (min-width: 768px) {
      padding-top: unset !important;
    }
  }

  .component-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-end;
    padding-top: 10vw;
    @media screen and (max-width: 1500px) {
      padding-top: 8vw;
    }
  }

  .page-title {
    @media screen and (max-width: 1300px) {
      font-size: 26px;
    }
  }

  @keyframes fadeInAnimation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @media screen and (max-width: 991px) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }

  .content-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    pointer-events: none;

    a,
    button {
      pointer-events: auto;
    }
  }

  .img-partner-placeholder {
    max-width: 48px;
    max-height: 48px;
    min-width: 48px;
    min-height: 48px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .current-progress {
    @media screen and (min-width: 576px) {
      max-width: 470px;
    }
    .btn-info {
      font-size: 16px;
      padding: 8px 16px;
      width: fit-content;
    }
  }

  img {
    max-width: 100%;
    width: 300px;

    @media screen and (max-width: 991px) {
      width: 150px;
    }
  }

  .certificate {
    position: absolute;
    bottom: 10%;
    right: 5%;

    @media screen and (max-width: 991px) {
      bottom: 2%;
    }
  }

  .btn-back {
    position: absolute;
    left: 10px;
    top: 15%;
    @media screen and (min-width: 992px) {
      left: 57px;
    }
  }

  .badge {
    font-size: 14px;
    font-weight: bold;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid #ffffff;
    color: white;
  }

  p {
    ::v-deep * {
      color: white !important;
    }
  }

  a {
    line-height: 34px;
  }

  .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    pointer-events: none;
    &.theme-dark {
      background: linear-gradient(
          -270deg,
          #0c0d13 -12%,
          rgba(11, 11, 18, 0.7) 12%,
          rgba(11, 11, 18, 0.5) 24%,
          rgba(11, 11, 18, 0.3) 43%,
          rgba(11, 11, 18, 0) 90%
        ),
        linear-gradient(
          0deg,
          #0c0d13 -1%,
          rgba(11, 11, 18, 0.7) 8%,
          rgba(11, 11, 18, 0.5) 18%,
          rgba(11, 11, 18, 0.3) 30%,
          rgba(11, 11, 18, 0.2) 40%,
          rgba(11, 11, 18, 0.1) 50%,
          rgba(11, 11, 18, 0) 70%
        );
    }

    &.theme-light {
      background: linear-gradient(
          0deg,
          #fff 4%,
          rgba(240, 241, 244, 0.7) 14%,
          rgba(240, 241, 244, 0.5) 22%,
          rgba(240, 241, 244, 0) 40%
        ),
        linear-gradient(
          -270deg,
          rgba(11, 11, 18, 0.7) 2%,
          rgba(11, 11, 18, 0.5) 24%,
          rgba(11, 11, 18, 0.3) 43%,
          rgba(11, 11, 18, 0) 90%
        );
    }
  }
}
</style>
